import { SettingsType } from "enum/SettingsType";
import moment from "moment-timezone";

export const setConditionalFieldValue = (setFieldValue: any, field: string, value: any) => {
  setFieldValue(field, value ? value : "");
};

export const setPickupAddress = (customer: any, setPickUpAddress: any, setpicValue: any, setIsPicked: any) => {
  if (customer?.address) {
    setPickUpAddress({
      city: customer.address.city,
      lat: customer.address.lat,
      lng: customer.address.lng,
      postalCode: customer.address.postalCode,
      companyName: customer.businessName,
    });

    setpicValue({ label: customer.address.city || "", placeId: "" });
    setIsPicked(true);
  } else {
    setPickUpAddress({ city: "", lat: 0, lng: 0, postalCode: "", companyName: "" });
  }
};

export const normalizeMomentToMinute = (date: moment.Moment) =>
  moment(date).second(0).millisecond(0);

export const getMinimumDeliveryDateTime = (pickupDateTime: moment.Moment) =>
  normalizeMomentToMinute(pickupDateTime).add(2, "hours");

export const isDeliveryAtLeastTwoHoursAfterPickup = (
  pickupDateTime: moment.Moment,
  deliveryDateTime: moment.Moment
) => !normalizeMomentToMinute(deliveryDateTime).isBefore(getMinimumDeliveryDateTime(pickupDateTime));

export const setDateTimeValues = (
  setPickupDateTime: any,
  setDeliveryDateTime: any,
  setMindate: any,
  roundUpToNext15Min: any
) => {
  const toronto = normalizeMomentToMinute(moment.tz("America/Toronto"));
  const roundedTime = roundUpToNext15Min(toronto.clone());

  if (toronto.hour() >= 9 && toronto.hour() < 21) {
    const pickup = toronto.clone();
    const pickupHour = pickup.hour();

    setPickupDateTime(roundedTime);
    setMindate(pickup);

    let maxHour = 17; // default 5 PM
    if (pickupHour >= 15) maxHour = 18; // ≥ 3 PM → 6 PM
    if (pickupHour >= 16) maxHour = 19; // ≥ 4 PM → 7 PM
    if (pickupHour >= 17) maxHour = 20; // ≥ 5 PM → 8 PM
    if (pickupHour >= 18) maxHour = 21; // ≥ 6 PM → 9 PM
    if (pickupHour >= 19) maxHour = 22; // ≥ 7 PM → 10 PM
    if (pickupHour >= 20) maxHour = 23; // ≥ 8 PM → 11 PM

    setDeliveryDateTime(pickup.hour(maxHour).minute(0).second(0).millisecond(0));
  } else if (toronto.hour() >= 21) {
    const nextBusinessDay = toronto.clone().add(1, "days");
    setMindate(nextBusinessDay.clone());
    setPickupDateTime(nextBusinessDay.clone().hour(9).minute(0).second(0).millisecond(0));
    setDeliveryDateTime(nextBusinessDay.clone().hour(17).minute(0).second(0).millisecond(0));
  } else {
    setPickupDateTime(toronto.clone().hour(9).minute(0).second(0).millisecond(0));
    setDeliveryDateTime(toronto.clone().hour(17).minute(0).second(0).millisecond(0));
  }
};

export const getSerivceSettingsType = (pickupDateTime: moment.Moment, deliveryDateTime: moment.Moment) => {
  const pickup = normalizeMomentToMinute(pickupDateTime);
  const delivery = normalizeMomentToMinute(deliveryDateTime);

  const nineAM = moment(pickup).set({ hour: 9, minute: 0, second: 0, millisecond: 0 });
  const two45PM = moment(pickup).set({ hour: 14, minute: 45, second: 0, millisecond: 0 });
  const threePM = moment(pickup).set({ hour: 15, minute: 0, second: 0, millisecond: 0 });
  const ninePM = moment(pickup).set({ hour: 21, minute: 0, second: 0, millisecond: 0 });

  // After-hours pricing: 3:00 PM – 9:00 PM
  if (pickup.isSameOrAfter(threePM) && pickup.isSameOrBefore(ninePM)) {
    return SettingsType.AFTER_HOURS;
  }

  // Regular tiered pricing: 9:00 AM – 2:45 PM
  if (pickup.isSameOrAfter(nineAM) && pickup.isSameOrBefore(two45PM)) {
    const diffHours = delivery.diff(pickup, "hours", true); // Calculate difference in hours

    if (diffHours >= 8) return SettingsType.ECONOMY;
    if (diffHours >= 6) return SettingsType.STANDARD;
    if (diffHours >= 4) return SettingsType.PRIORITY;
    if (diffHours >= 2) return SettingsType.RUSH;
  }

  return SettingsType.ECONOMY;
};
